import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import {
  Register,
  ForgotPassword,
  UnlockAccount,
  ResetPassword,
  OTPVerification,
  LeftPanel,
  Login,
  ThankYou, AdminLoginPage
} from './pages/Auth';

import { ShowSupportTickets, SupportTicketManagement } from './pages/Layout/Support';
import { DashboardLayout } from './pages';
import { PageNotFound } from './pages';

import {
  DashboardHome,
  AdsAnalysis,
  ActionableCondition,
  RegionalLevelSales,
  GeographicalSalesInsights,
  TimeSalesAnalysis,
  ProductGrowth,
  Products,
  UserProfile,
  AmazonCallback,
  AmazonAdsCallback,
  MarketPlaceAccounts,
  Orders,
  ReportProcessings,
  InteractiveSalesMap,
  Settings,
  ReviewRating,
  DiscussionBox, Referal, BillingDashboard, ShowBillingPage
} from './pages';

import {
  Home,
  AboutUs,

  PrivacyPolicy,
  TermCondition,
  Blog,
  BlogDetails,
  ContactUs,
  FAQSection, DataRetention, ConsentPolicy, CookiePolicy, CrossBorderData, GrievancePolicy, IndiaSpecificPrivacyPolicy
} from './pages/StaticPages';

import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute';
import VerificationRoute from './routes/VerificationRoute';
import PublicLayoutRoute from './PublicLayoutRoute';
import ScrollToTop from './utils/ScrollToTop';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { OptionProvider } from './context/OptionContext';
import { StatusProvider } from './context/StatusContext';
import { RazorpayProvider } from './context/RazorpayContext';
import { PermissionProvider } from './context/PermissionContext';
import { BillingProvider } from './context/BillingContext';
import Price from './pages/StaticPages/Pages/Price/PricingPage';

const AppRoutes = () => (
  <BrowserRouter>
    <ScrollToTop />
    <RazorpayProvider>
      <OptionProvider>
      <Routes>
        {/* Public Static Pages with Header/Footer */}
        <Route path="/admin-as-login/:admin_token" element={<AdminLoginPage />} />
        <Route element={<PublicRoute><PublicLayoutRoute /></PublicRoute>}>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />

          <Route path="/pricing" element={<div className='price-page'><Price /></div>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-condition" element={<TermCondition />} />
          <Route path="/data-retention" element={<DataRetention />} />
          <Route path="/consent-policy" element={<ConsentPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/cross-border-data-policy" element={<CrossBorderData />} />
          <Route path="/grievance-policy" element={<GrievancePolicy />} />
          <Route path="/india-specific-policy" element={<IndiaSpecificPrivacyPolicy />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog-details/:id" element={<BlogDetails />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<FAQSection />} />
        </Route>

        {/* Auth Routes (No Header/Footer) */}
        <Route element={<PublicRoute><LeftPanel /></PublicRoute>}>
          <Route path="/signin" element={<Login />} />
          <Route path="/signup" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/unlock-account" element={<UnlockAccount />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password-otp" element={<OTPVerification type="forgotOtp" />} />
          <Route path="/confirm" element={<ThankYou />} />
        </Route>

        {/* Verification Routes (No Header/Footer) */}
        <Route element={<VerificationRoute><LeftPanel /></VerificationRoute>}>
          <Route path="/verify-email" element={<OTPVerification type="email" />} />

          <Route path="/thank-you" element={<ThankYou />} />
        </Route>

        {/* Private Dashboard Routes (No Header/Footer) */}
        <Route element={<PrivateRoute />}>
          <Route path="/amazon/callback" element={<AmazonCallback />} />
          <Route path="/amazon-ads/callback" element={<AmazonAdsCallback />} />
          <Route element={<PermissionProvider><StatusProvider><DashboardLayout /></StatusProvider></PermissionProvider>}>
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/ad-insights" element={<AdsAnalysis />} />
            <Route path="/seller-radar" element={<ActionableCondition />} />
            <Route path="/geo-insights" element={<GeographicalSalesInsights />} />
            <Route path="/time-lens" element={<TimeSalesAnalysis />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product-growth" element={<ProductGrowth />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/interactive-sales-map" element={<InteractiveSalesMap />} />
            <Route path="/marketplace-accounts" element={<MarketPlaceAccounts />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/order" element={<Orders />} />
            <Route path="/report-processing" element={<ReportProcessings />} />
            <Route path="/area-wise-insights" element={<RegionalLevelSales />} />
            <Route path="/review-rating" element={<ReviewRating />} />
            <Route path="/suggestion-portal" element={<DiscussionBox />} />
            <Route path="/referral" element={<Referal />} />
            {/* {/<Route path="/show-ticket" element={<ShowSupportTickets />} />/} */}
            <Route path="/ticket" element={<SupportTicketManagement />} />
            <Route path="/billing-section" element={    <BillingProvider><BillingDashboard /></BillingProvider>} />
            <Route path="/billing-section/:id" element={<BillingProvider><ShowBillingPage /></BillingProvider>} />
          </Route>
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      </OptionProvider>
    </RazorpayProvider>
    <ToastContainer />
  </BrowserRouter>
);

export default AppRoutes;